import {
  JWT_LOCAL_STORAGE_KEY,
  IMPERSONATOR_JWT_LOCAL_STORAGE_KEY,
} from 'src/constants/config';

export const saveJWTToken = (token: string) => {
  return localStorage.setItem(JWT_LOCAL_STORAGE_KEY, token);
};

export const getJWTToken = () => {
  return localStorage.getItem(JWT_LOCAL_STORAGE_KEY);
};

export const clearJWTToken = () => {
  localStorage.removeItem(JWT_LOCAL_STORAGE_KEY);
};

export const saveImpersonatorJWTToken = (token: string) => {
  return localStorage.setItem(IMPERSONATOR_JWT_LOCAL_STORAGE_KEY, token);
};

export const getImpersonatorJWTToken = () => {
  return localStorage.getItem(IMPERSONATOR_JWT_LOCAL_STORAGE_KEY);
};

export const clearImpersonatorJWTToken = () => {
  localStorage.removeItem(IMPERSONATOR_JWT_LOCAL_STORAGE_KEY);
};
